var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-container"},[_c('v-alert',{staticClass:"custom-size",attrs:{"value":_vm.showAlert,"transition":"scale-transition","type":_vm.type}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }